import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'
// 使用中文提示
const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  validity: false
}
Vue.use(VeeValidate, config)
const dictionary = {
  en: {
    messages: {
      mobiles: (filed) => 'Please enter 5 to 21 number'
    },
    attributes: {
      // project: ''
      email: 'Email'
    }
  },
  zh: {
    messages: {
      email: (filed) => '请输入正确邮箱格式',
      mobiles: (filed) => '请输入5-21位数字',
      required: (filed) => `${filed}未填写`,
      description: (field) => '描述接入后展示的位置必须 10 字以上'
    },
    attributes: {
      project: '企业或项目',
      email: '邮箱',
      name: '姓名',
      phone: '手机号',
      app_name: '网址或者网APP名称',
      description: '描述接入后展示的位置'
    }
  }
}
Validator.localize('zh', zh)
Validator.localize(dictionary)
// const validator = new Validator({ first_name: 'alpha' });
// validator.localize('ar')

// // 自定义验证规则
// /**
//   * 网站名称
//   * 12个字符
//   * 汉字或数字
//   */
Validator.extend('mobiles', {
  // messages: {
  //   zh: (filed) => '手机号码输入不正确',
  //   en: (filed) => 'test test test'
  // },
  // getMessage: (filed) => { console.log(filed) },
  // en: {
  // getMessage: (filed) => 'test test test',
  // },
  // zh: {
  //   getMessage: (filed) => '手机号码输入不正确'
  // },
  // validate: value => value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  validate: value => /^\d{5,21}$/.test(value)
})
Validator.extend('web', {
  getMessage: (filed) => `${filed}须是不大于12个字符的汉字或数字！`,
  validate: value => /^[0-9\u4e00-\u9fa5]+$/g.test(value) && value.length <= 12
})

Validator.extend('web', {
  // getMessage: (filed) => `${filed}须是不大于12个字符的汉字或数字！`,
  getMessage: {
    zh: (field) => '手机号码输入不正确',
    en: (filed) => 'test test test'
  },
  validate: value => /^[0-9\u4e00-\u9fa5]+$/g.test(value) && value.length <= 12
})
/**
 * 网站logo
 * 2m以内
 */
Validator.extend('image', {
  getMessage: (filed) => `${filed}须是不大于2M的图片！`,
  validate: value => {
    return value[0].size < 2097152 && /image/.test(value[0].type)
  }
})
/**
 * 网站简介
 * 140个字符
 * 汉字或数字
 */
Validator.extend('websit', {
  getMessage: filed => `${filed}须是不大于12个字符的汉字或数字！`,
  validate: value => (/^[0-9\u4e00-\u9fa5]+$/g.test(value)) && (value.length <= 140)
})
/**
 * 网址
 * 30个字符
 * 只能为字符：字母与htp/:.
 */
Validator.extend('url', {
  getMessage: filed => `${filed}须包含http或https协议且不超过30个字符`,
  validate: value => {
    var reg = (/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/g)
    return reg.test(value) && value.length <= 30
  }
})

/**
 * 访问量
 * 30个字符
 * 只能为数字
 */
Validator.extend('volume', {
  getMessage: filed => `${filed}须是不大于30个字符的数字！`,
  validate: value => ((/^[+-]?\d+(\.\d+)?$|^$|^(\d+){7,}$/g).test(value)) && (value.length <= 30)
})
/**
 * Alexa排名
 * 30个字符
 * 数字
 */
Validator.extend('rank', {
  getMessage: filed => `${filed}须是不大于30个字符的数字！`,
  validate: value => (/^[+-]?\d+(\.\d+)?$|^$|^(\d+){7,}$/g.test(value)) && (value.length <= 30)
})
/**
 * 联系人
 * 12个字符
 * 汉字
 */
Validator.extend('contacts', {
  getMessage: filed => `${filed}须是不大于12个字符的汉字！`,
  validate: value => (/[\u4e00-\u9fa5]/g.test(value)) && (value.length <= 12)
})
/**
 * 联系方式
 * 30个字符
 * 汉字或数字 汉字？？
 */
Validator.extend('phone', {
  getMessage: filed => `${filed}须是不能大于30个字符的数字！`,
  validate: value => /^[+-]?\d+(\.\d+)?$|^$|^(\d+){7,}$/g.test(value) && value.length <= 30
})

/**
 * 描述
 */
Validator.extend('description', {
  getMessage: filed => `${filed}须是不能少于 10 个汉字！`,
  validate: value => {
    return strLen(value) >= 20
  }
})

function strLen (str) { // 获取字符串的字节数
  var count = 0 // 初始化字节数递加变量并获取字符串参数的字符个数
  if (str) { // 如果存在字符串，则执行
    var len = str.length
    for (var i = 0; i < len; i++) { // 遍历字符串，枚举每个字符
      if (str.charCodeAt(i) > 255) { // 字符编码大于255，说明是双字节字符(即是中文)
        count += 2 // 则累加2个
      } else {
        count++ // 否则递加一次
      }
    }
    console.log(count)
    return count // 返回字节数
  } else {
    console.log(0)
    return 0 // 如果参数为空，则返回0个
  }
}
